import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, border, mediaQuery } = baseVariables;

export const StyledGuestRoomRatesSkeletonLoader = styled.div`
  .skeleton-loader {
    transition: height 0.3s ease, opacity 0.3s ease;
    border-radius: ${toRem(5)};
  }

  .loader,
  .guestroomlist-item,
  .loader-card {
    border-radius: ${toRem(12)};
  }

  .loader-card {
    padding: ${toRem(40)} ${toRem(16)};
    background-color: ${color.base20};
    border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
    box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

    @media ${mediaQuery.md} {
      padding: ${toRem(40)} ${toRem(32)};
    }
  }

  .eventype-loader-container {
    height: ${toRem(200)};
  }

  .guestroomlist-loader-container {
    height: ${toRem(534)};
    padding: ${toRem(10)} 0;

    .guestroomlist-item {
      height: ${toRem(156)};
      margin: ${toRem(10)} 0;
    }

    @media ${mediaQuery.md} {
      height: ${toRem(434)};
      .guestroomlist-item {
        height: ${toRem(276)};
      }
    }
  }

  .guestroom-selection-loader {
    height: ${toRem(480)};
  }

  .guestroom-section-loader {
    height: ${toRem(778)};
  }
`;

export const TextPlaceLoader = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '80%'} !important;
  height: ${toRem(20)};
  margin-bottom: ${toRem(2)};
`;

export const StyledLoaderDivider = styled.div`
  margin: ${toRem(20)} 0;
  border-top: ${toRem(1)} solid ${color.neutral30};
`;
